<script lang="ts">
  import { getContext, createEventDispatcher } from "svelte";
  import type { Readable } from "svelte/store";
  import type { Control } from "../../forms/controls";
  import InputCheckbox from "../../forms/InputCheckbox.svelte";

  export let label: string;
  export let value: any;
  export let disabled: boolean = false;

  const changes = getContext<Readable<Control>>("CheckboxGroup");
  $: ctrl = $changes;
  $: checked = Array.isArray(ctrl.value) ? ctrl.value.includes(value) : false;

  const dispatch = createEventDispatcher();

  function handleClick() {
    let array = Array.isArray(ctrl.value) ? [...ctrl.value] : [];

    if (array.includes(value)) {
      array = array.filter((_) => _ !== value);
    } else {
      array.push(value);
    }

    ctrl.value = array;

    dispatch("change", { value, selected: array.includes(value) });
  }
</script>

<InputCheckbox
  {checked}
  {disabled}
  on:change={(e) => {
    if (e.detail.value !== checked) handleClick();
  }}
  standalone
>
  {label}
</InputCheckbox>
